import React from 'react';
import AppLayout from '../../layout/AppLayout';
import DashboardAccountMenu from './DashboardAccountMenu';
import './DashboardPageShell.css';

function joinClassNames(...classNames) {
  return classNames.filter(Boolean).join(' ');
}

function renderDefaultHeaderActions(productDashboardShell) {
  return ({ logout, navigate, session, activeCustomerName }) => (
    <DashboardAccountMenu
      customerName={activeCustomerName}
      label={productDashboardShell === 'operator' ? 'User' : 'Account'}
      logout={logout}
      navigate={navigate}
      session={session}
    />
  );
}

export default function DashboardPageShell({
  children,
  contentClassName,
  contentInnerClassName,
  contentInnerStyle,
  contentStyle,
  headerClassName,
  headerStyle,
  renderHeaderActions,
  productDashboardShell,
  shellClassName,
  title,
  ...layoutProps
}) {
  return (
    <AppLayout
      {...layoutProps}
      title={title}
      frameless
      productDashboardShell={productDashboardShell}
      renderHeaderActions={renderHeaderActions || renderDefaultHeaderActions(productDashboardShell)}
      headerClassName={joinClassNames(
        'dashboard-page-shell-header',
        headerClassName,
      )}
      headerStyle={headerStyle}
      contentClassName={joinClassNames(
        'dashboard-page-shell-content',
        contentClassName,
      )}
      contentStyle={contentStyle}
      contentInnerStyle={contentInnerStyle}
    >
      <div className={joinClassNames('dashboard-page-shell', shellClassName)}>
        <div
          className={joinClassNames(
            'dashboard-page-shell-inner',
            contentInnerClassName,
          )}
        >
          {children}
        </div>
      </div>
    </AppLayout>
  );
}
